<template>
  <div id="privacyPolicy">

    
     
      <div class="row row-title certifiche">
      <div class="mainbox">
          <parallax-container>
            <parallax-element :parallaxStrength="-5" :type="'translation'"
                              v-bind:style="(myWidth > 768) ? {'marginTop': + pageHeight*2/3 + 'px'} : {'marginTop': + (pageHeight-450) + 'px'}">
             
              <div class="col-lg-offset-5 col-lg-12 autore"
                   style="position: relative; -webkit-animation: moving 15s infinite; animation: moving 15s infinite">
                Privacy & Cookie Policy
              </div>
            </parallax-element>
          </parallax-container>
        </div>
      
    </div>
   
    <div class="cp none">
    <a
      href="https://www.iubenda.com/privacy-policy/30186386"
      class="iubenda-white no-brand iubenda-noiframe iubenda-embed iubenda-noiframe iub-body-embed"
      title="Privacy Policy"
      target="_blank"
      rel="noopener noreferrer"
    >
     <span class="titolo none">Privacy Policy</span> 
    </a>
  </div>
    <Footer></Footer>
  </div>
</template>

<script>
  import HeaderPage from './HeaderPage'
  import Footer from './Footer'
  import RoomSlider from './RoomSlider'
  import moment from 'moment'
  import ModalCovid from "./global/EventModal";
  import EventModal from "./global/EventModal";

  export default {
    name: 'privacyPolicy',
    components: {EventModal, ModalCovid, RoomSlider, Footer, HeaderPage},
    data() {
      return {
        policyContent: '',
        loading: true,
        error: null,
      }
    },
    props: {
      pageHeight: {
        type: Number,
        required: true,
        default: 700
      }
    },
    i18n: {
      fallbackLocale: 'it', // default lang,
      messages: {
        it: {
        },
        en: {
        }
      }
    },
    updated: function () {
      window.addEventListener('resize', this.getPageHeight)
    },
    mounted: function () {
      this.loadScripts();
      this.loadIubendaScript();
    },
    methods: {
      loadIubendaScript() {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = 'https://cdn.iubenda.com/iubenda.js';
      script.async = true;
      document.body.appendChild(script);
    },
      loadScripts() {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = 'https://cdn.iubenda.com/iubenda.js';
      script.async = true;
      document.body.appendChild(script);
    },
      async fetchUserInfo() {
  const token = localStorage.getItem('authToken');

  if (!token) {
    console.error('Utente non autenticato.');
    return;
  }

  try {
    const response = await fetch('https://app.hubspot.com/api/login-verify/hub-user-info', {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.ok) {
      throw new Error(`Errore: ${response.status}`);
    }

    const userInfo = await response.json();
    console.log(userInfo);
  } catch (error) {
    console.error('Errore nel recupero delle informazioni utente:', error);
  }
},

    }
  }
</script>

<style lang="less">
  @import "../assets/less/variabili.less";
  @import "../assets/less/font.less";

  #checkIn, #checkOut {
    width: 140px;
  }

  #privacyPolicy {
    input[type=number] {
      text-align: center;
      font-weight: normal;
      outline: none;
      padding: 3px;
    }
    input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
      -webkit-appearance: initial;
      margin: 0;
    }
    background-color: @lightBlack;

    .certifiche {
      background-image: url("../../static/image/cookiepolicy.jpg");
      text-align: center;
      height: 450px;
      background-size: cover;
      -webkit-box-shadow: inset 200px 200px 300px 200px rgba(0, 0, 0, 0.49);
      -moz-box-shadow: inset 200px 200px 300px 200px rgba(0, 0, 0, 0.49);
      box-shadow: inset 200px 200px 200px 300px rgba(0, 0, 0, 0.49);
      .set-font-title();
      padding-top: 25px;
    }

    .line {
      background-color: @lightBlack;
    }
.row-title{
  display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-end;
    padding-right: 40px;
}
    .row {
    margin: 0px;
      margin: 0px;
      .titolo {
        padding-top: 25px;
        text-align: center;
        .set-font-title();
      }
      .testo {
        .set-font();
        padding-bottom: 20px;
      }
      .videocontainer {
        text-align: center;
        .video {
          border: none;
          margin-top: 40px;
          width: 85%;
          height: 85%;
        }
      }
      .titolo1 {
        padding-top: 25px;
        text-align: center;
        .set-font-title(@color: black);
      }
      .testo1 {
        .set-font(@color: black);
        padding-bottom: 20px;
        .nome {
          .set-font-nome(@color: black)
        }
      }
    }
    .none {
      display: none;
    }
    .cp {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -ms-flex-line-pack: center;
    align-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 40px;
}

    .imgsvg {
      .cls-1, .cls-12, .cls-16 {
        fill: none;
      }

      .cls-2 {
        fill: #914c7c;
      }

      .cls-3 {
        fill: #5d2561;
      }

      .cls-4 {
        fill: #e9ba51;
      }

      .cls-5 {
        fill: #f9db90;
      }

      .cls-6 {
        fill: #89ae8b;
      }

      .cls-7 {
        fill: #4d8a75;
      }

      .cls-8 {
        fill: #3a513f;
        stroke: #445c68;
        stroke-width: 2px;
      }

      .cls-12, .cls-16, .cls-19, .cls-8 {
        stroke-linecap: round;
        stroke-linejoin: round;
      }

      .cls-9 {
        fill: #445c68;
      }

      .cls-10, .cls-11, .cls-17, .cls-29 {
        fill: #fff;
      }

      .cls-11 {
        stroke: #fff;
        stroke-width: 0.5px;
      }

      .cls-11, .cls-29 {
        stroke-miterlimit: 10;
      }

      .cls-12, .cls-16 {
        stroke: #d0c7b0;
      }

      .cls-12 {
        stroke-width: 6px;
      }

      .cls-13 {
        fill: #4b842b;
      }

      .cls-14 {
        fill: #603106;
      }

      .cls-15 {
        fill: #98a631;
      }

      .cls-16 {
        stroke-width: 11px;
      }

      .cls-17 {
        font-size: 29px;
        font-family: Lato-Regular, Lato;
      }

      .cls-18 {
        letter-spacing: -0.06em;
      }

      .cls-19 {
        fill: #3496a4;
        stroke: #dcddde;
        stroke-width: 3px;
      }

      .cls-20 {
        fill: #a9582a;
      }

      .cls-21 {
        fill: #ab7821;
      }

      .cls-22 {
        fill: #847f85;
      }

      .cls-23 {
        fill: url(#inclinato_bianco);
      }

      .cls-24 {
        fill: #6f6f72;
      }

      .cls-25 {
        fill: url(#New_Pattern_Swatch_4);
      }

      .cls-26 {
        fill: url(#inclinato);
      }

      .cls-27 {
        fill: url(#New_Pattern_Swatch_6);
      }

      .cls-28 {
        fill: url(#New_Pattern_Swatch_1);
      }

      .cls-29 {
        stroke: #6f6f72;
        stroke-width: 0.25px;
      }
    }

    .attivita {
      text-align: center;
      margin-top: 50px;
      .set-font-title();
      .immagine {
        width: 85% !important;
      }

      .info {
        width: 230px;
        background-color: @myOrange;
        border-color: @borderOrange;
        margin: auto;
        text-align: center;
        display: inherit;
        letter-spacing: 1px;
        margin-bottom: 50px;
        margin-top: 30px;
        .set-font()
      }

      .info:hover {
        background-color: #f2ac35;
      }
    }
  }
  #iubenda_policy {
    .iub_content {
        color: white!important;
    }
    h1 {
        color: white!important;
    }
    h2 {
        color: white!important;
    }
    .iconed ul li h3 {
        color: #fff!important;
    }
    h3 {
        color: white!important;
    }
    .box_primary {
        background: #9d9d9d!important;
    }
    a {
        color: #c1c2c3!important;
    }
  } 
  #iubenda_policy.iubenda_embed_policy .iub_container>.iub_footer {
        display: none!important;
    }

  

  @media (max-width: 767px) {
    #privacyPolicy {
      .roomslider {
       
        .certifiche {
        height: auto;
        padding-bottom: 20px;
        .set-font-title(@size: 30px);
        .cert {
          padding: 20px;
        }
      }
      }
      
    }
  }

  @media (min-width: 768px) and (max-width: 1024px) {
  }


  @media (min-width: 1025px) and (max-width: 1366px) {
    /* Regole per schermi medi */
  }
</style>




// WEBPACK FOOTER //
// src/components/PrivacyCookiePolicy.vue